module.exports = __webpack_public_path__ + "static/media/luong-gio-coanda.b36ef1bb.svg";